<template>
    <div>
        <footer>
            <!-- Información legal -->
            <div class="container-fluid texto row">
                <div class="col d-flex px-5 py-3">
                    <div>Copyright -  AbaKan Sistemas - <small>v{{ version }}</small></div>
                    <div class="ml-auto pr-4">
                        <!-- <router-link to="/avisolegal" class="pr-3">Aviso Legal</router-link>
                        <router-link to="/condiciones" class="pr-3">Condiciones Generales</router-link>
                        <router-link to="/politica" class="pr-3">Política de Privacidad</router-link>
                        <router-link to="/cookies" class="pr-3">Cookies</router-link>
                        <router-link to="/contacto" class="pr-3">Contacto</router-link>    -->
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>

export default {
    name: 'AppFooter',
    components: {

    },
    data: () => ({
        titulo: 'Footer Aplicacion',

    }),
    methods: {

    },
    computed: {
        version() {
            return process.env.VUE_APP_VERSION;
        },
    },

}
</script>
